import { render, staticRenderFns } from "./BackgroundCircle.vue?vue&type=template&id=2407a91d&"
import script from "./BackgroundCircle.vue?vue&type=script&lang=js&"
export * from "./BackgroundCircle.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundCircle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports